import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const CurrencyIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <path
        d="M4 19C3.45 19 2.97917 18.8042 2.5875 18.4125C2.19583 18.0208 2 17.55 2 17V7C2 6.45 2.19583 5.97917 2.5875 5.5875C2.97917 5.19583 3.45 5 4 5H20C20.55 5 21.0208 5.19583 21.4125 5.5875C21.8042 5.97917 22 6.45 22 7V17C22 17.55 21.8042 18.0208 21.4125 18.4125C21.0208 18.8042 20.55 19 20 19H4ZM4 17H20V7H4V17ZM17.5 14.5H15.75C15.5333 14.5 15.3542 14.5708 15.2125 14.7125C15.0708 14.8542 15 15.0333 15 15.25C15 15.4667 15.0708 15.6458 15.2125 15.7875C15.3542 15.9292 15.5333 16 15.75 16H18C18.2833 16 18.5208 15.9042 18.7125 15.7125C18.9042 15.5208 19 15.2833 19 15V12.75C19 12.5333 18.9292 12.3542 18.7875 12.2125C18.6458 12.0708 18.4667 12 18.25 12C18.0333 12 17.8542 12.0708 17.7125 12.2125C17.5708 12.3542 17.5 12.5333 17.5 12.75V14.5ZM12 15C12.8333 15 13.5417 14.7083 14.125 14.125C14.7083 13.5417 15 12.8333 15 12C15 11.1667 14.7083 10.4583 14.125 9.875C13.5417 9.29167 12.8333 9 12 9C11.1667 9 10.4583 9.29167 9.875 9.875C9.29167 10.4583 9 11.1667 9 12C9 12.8333 9.29167 13.5417 9.875 14.125C10.4583 14.7083 11.1667 15 12 15ZM6.5 9.5H8.25C8.46667 9.5 8.64583 9.42917 8.7875 9.2875C8.92917 9.14583 9 8.96667 9 8.75C9 8.53333 8.92917 8.35417 8.7875 8.2125C8.64583 8.07083 8.46667 8 8.25 8H6C5.71667 8 5.47917 8.09583 5.2875 8.2875C5.09583 8.47917 5 8.71667 5 9V11.25C5 11.4667 5.07083 11.6458 5.2125 11.7875C5.35417 11.9292 5.53333 12 5.75 12C5.96667 12 6.14583 11.9292 6.2875 11.7875C6.42917 11.6458 6.5 11.4667 6.5 11.25V9.5Z"
        fill={color}
      />
    </svg>
  );
};

export default CurrencyIcon;
